var map = {
	"./Afghanistan.jpg": 295,
	"./Albania.jpg": 296,
	"./Algeria.jpg": 297,
	"./Argentina.jpg": 298,
	"./Australia.jpg": 299,
	"./Austria.jpg": 300,
	"./Bahrain.jpg": 301,
	"./Bangladesh.jpg": 302,
	"./Belgium.jpg": 303,
	"./Brazil.jpg": 304,
	"./Canada.jpg": 305,
	"./China.jpg": 306,
	"./Denmark.JPG": 307,
	"./Finland.jpg": 308,
	"./France.jpg": 309,
	"./Germany.jpg": 310,
	"./Greece.jpg": 311,
	"./HongKong.jpg": 312,
	"./Iceland.jpg": 313,
	"./India.jpg": 314,
	"./Indonesia.jpg": 315,
	"./Ireland.jpg": 316,
	"./Italy.jpg": 317,
	"./Japan.jpg": 318,
	"./Kenya.jpg": 319,
	"./Korea.jpg": 320,
	"./Malaysia.jpg": 321,
	"./Mali.jpg": 322,
	"./NewZealand.jpg": 323,
	"./Nigeria.jpg": 324,
	"./Norway.jpg": 325,
	"./Qatar.jpg": 326,
	"./Russia.jpg": 327,
	"./Singapore.jpg": 328,
	"./Sweden.jpg": 329,
	"./Switzerland.jpg": 330,
	"./UK.jpg": 331,
	"./USA.jpg": 332,
	"./a_default_boys.jpg": 333,
	"./a_default_earth.jpg": 135,
	"./a_default_kids_protesting.jpg": 334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;